import React, { useContext, useState } from 'react';
import { View } from 'react-native';
import FileDownload from 'js-file-download';

import { rest } from '../utils/rest';
import AuthContext from '../contexts/AuthContext';
import { Button, ButtonGroup } from 'app/src/elements/buttons';

export const downloadReport = props => {
  const { path, filename, credentials, params, type, setDownloading } = props;
  setDownloading(type);

  const options = {
    credentials,
    params,
    path: `report-builder/${path}.xlsx`,
    headers: {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  };

  const timestamp = new Date().getTime();
  let fullFilename = `${filename || path}-${timestamp}.xlsx`;

  if ('pdf' === type) {
    options.path = `report-builder/${path}.pdf`;
    options.headers.Accept = 'application/pdf';
    fullFilename = `${filename || path}-${timestamp}.pdf`;
  };

  rest(options).then(response => {
    response.blob().then(blob => FileDownload(blob, fullFilename));
    setDownloading(false);
  });
};

export const DownloadButton = ({ label, handleDownload }) => {
  const [downloading, setDownloading] = useState();
  const { credentials } = useContext(AuthContext);

  return (
    <View>
      <ButtonGroup>
        <Button
          label={'xlsx' === downloading ? '...' : 'Download Excel'}
          onPress={() => (
            handleDownload({ credentials, type: 'xlsx', setDownloading })
          )}
        />
        <Button
          label={'pdf' === downloading ? '...' : 'Download PDF'}
          onPress={() => (
            handleDownload({ credentials, type: 'pdf', setDownloading })
          )}
        />
      </ButtonGroup>
    </View>
  );
};
